module.exports = __webpack_public_path__ + "static/media/wells-on-wheels.11118997.png";